
import actionCreatorFactory from 'typescript-fsa';
import * as types from './types';
import { GenActionFactoryName } from 'shared/helpers/redux-helpers';
import { IDiagnoseCategory, SyncDataDiagnoseCategory } from 'shared/api/api';

const actionCreator = actionCreatorFactory(GenActionFactoryName('diagnoseCategory'));

export const saveDiagnoseCategory = actionCreator.async<
    IDiagnoseCategory,
    string,
    { code: number; message: string; prevEntity: IDiagnoseCategory | undefined }
>(types.SAVE_DIAGNOSECATEGORY);
export const getSyncData = actionCreator.async<{ lastSyncDate: Date }, SyncDataDiagnoseCategory>(
    types.SYNC_DATA_DIAGNOSECATEGORIES
);
